module.exports = __webpack_public_path__ + "static/media/camara.1e50b0e5.png";